import React, { lazy, Suspense, memo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Loading from 'components/shared-components/Loading';
// import AnnouncementBanner from 'components/shared-components/AnnouncementBanner';
import Views from 'views';
import openreplayService from 'services/openreplayService';
import VersionWatcher from 'components/shared-components/VersionWatcher';

const AppLayout = lazy(() => import('./AppLayout'));
const AuthLayout = lazy(() => import('./AuthLayout'));

const Layouts = () => {
  const token = useSelector((state) => state.auth.token);
  const booting = useSelector((state) => state.auth.booting);
  const blankLayout = useSelector((state) => state.theme.blankLayout);
  const direction = useSelector((state) => state.theme.direction);
  const navType = useSelector((state) => state.theme.navType);
  const navCollapsed = useSelector((state) => state.theme.navCollapsed);

  // OpenReplay: el disparador vive aquí (Layouts siempre está montado) y
  // reacciona solo al estado de autenticación. Usar el booleano !!token evita
  // que cambios de blankLayout u otros re-renders corten/reinicien la sesión.
  // Inicia la grabación al autenticarse y la detiene al cerrar sesión.
  // Solo corre en producción (gateado dentro del servicio).
  const isAuthenticated = !!token;
  useEffect(() => {
    if (isAuthenticated) {
      (async () => {
        try {
          await openreplayService.initAndStart();
        } catch (error) {
          console.error('[Layouts] ❌ Error initializing OpenReplay:', error);
        }
      })();
    } else {
      try {
        openreplayService.stop();
      } catch (error) {
        console.error('[Layouts] ❌ Error stopping OpenReplay:', error);
      }
    }
  }, [isAuthenticated]);

  // Mientras authClient.boot() decide si la cookie de refresh vale (App.js),
  // no se pinta ni la app ni el login: sin esto se vería el login un instante
  // en cada F5 de una sesión buena.
  if (booting) return <Loading cover="page" />;

  const Layout = token && !blankLayout ? AppLayout : AuthLayout;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
      }}
    >
      {/* <AnnouncementBanner /> */}
      <VersionWatcher />
      <Suspense fallback={<Loading cover="content" />}>
        <Layout
          direction={direction}
          navType={navType}
          navCollapsed={navCollapsed}
          style={{ flex: '1 1 auto', overflow: 'hidden' }}
        >
          <Views />
        </Layout>
      </Suspense>
    </div>
  );
};

export default memo(Layouts);
